import React from 'react';
import { NavLink } from 'react-router-dom';
const CopyControl = props => (props.copying ?
    React.createElement(React.Fragment, null,
        React.createElement(NavLink, { to: `/multi-edit/${props.cat}?data=${props.data_string}`, className: "icon-button copy" }, "Copy selected"),
        React.createElement("a", { className: "icon-button copy", onClick: props.toggleCopying }, "Cancel"))
    :
        React.createElement("a", { className: "icon-button copy", onClick: props.toggleCopying }, "Copy"));
export { CopyControl };
